import { Flags } from './Flags'

export function flagSelector(country: string) {
  const Flag = Flags[country]
  if (!Flag) {
    console.error(`No flag found for country code "${country}"`)
    return null
  }
  return Flag
}
